import * as plugins from './plugins.js';

import { html } from '@design.estate/dees-element';

import './elements/index.js';
import { appRouter } from './router.js';

// Initialize router before rendering
appRouter.init();

plugins.deesElement.render(html`
  <ops-dashboard></ops-dashboard>
`, document.body);
